/**
 * Builds the top-level org Record workspace URL.
 */
export function getOrgRecordWorkspacePath(input: {
	orgId: string;
	recordId: string;
	tab?: string;
}): string {
	const tab = input.tab ?? "form";
	return `/web/${input.orgId}/records/${input.recordId}/workspace/${tab}`;
}

/**
 * Builds the Record detail drawer URL for a top-level org record instance.
 */
export function getOrgRecordDrawerDetailsPath(input: {
	orgId: string;
	recordId: string;
	tab?: string;
}): string {
	const tab = input.tab ?? "details";
	return `/web/${input.orgId}/records/${input.recordId}/${tab}`;
}
